import Qs from 'qs';

const { fetch } = global

export const fetchCart = () => fetch('/cart.json')

export const addVariantToCart = (variantId, selling_plan = '', quantity = 1, properties = {}) =>
  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity,
        selling_plan,
        properties
      }]
    }),
  })

export const updateVariantQuantity = (variantId, quantity = 1) =>
  fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: `${variantId}`,
      quantity,
    }),
  })

export const updateCartAttributes = (attributes = {}) =>
  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ attributes }),
  })


export const graphQl = (query) =>
  fetch('/api/2023-07/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Shopify-Storefront-Access-Token': '235d1dc2437c1abb8e7ceb5d802949ba',
    },
    body: JSON.stringify({ query })
  })
  .then(r => r.json())


export const search = (query, resources= {}) => {
  const params = {
    q: query,
    resources,
  }

  return fetch(`/search/suggest.json?${Qs.stringify(params, { encode: false })}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  })
    .then(r => r.json())
}
